import React, { useState,useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import {
  Layout,
  LoginPage,
  Logout,
  Error404,
} from "./routing/componentRoutes";
import { Dashboard, Karyawan,Jabatan, Tunjangan,Absensi,ReportAbsensi, Profile,Password,System,Role,Permission, Lembur, LemburKaryawan, Potongan, Insentive, ReportLembur, ReportPotongan, ReportInsentive, ReportGaji, Gaji, MasterTunjangan, Bpjs, MasterTunjanganKaryawan } from "./routing/pageRoutes";

function App() {

  useEffect(() => {
    document.title = "Smart Payroll Apps | KSI"; 
  }, []);

  

  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/dashboard" element={<Layout breadcrumb={['Dashboard']}><Dashboard /></Layout>} />
        
        {/* MASTER */}
        <Route path="/master/karyawan" element={<Layout breadcrumb={['Master Data','Karyawan']}><Karyawan /></Layout>} />
        <Route path="/master/jabatan" element={<Layout breadcrumb={['Master Data','Jabatan']}><Jabatan /></Layout>} />
        <Route path="/master/master-tunjangan" element={<Layout breadcrumb={['Master Data','Master Tunjangan']}><MasterTunjangan /></Layout>} />
        
        {/* TRANSAKSI */}
        <Route path="/transaksi/gaji" element={<Layout breadcrumb={['Layanan','Gaji']}><Gaji /></Layout>} />
        <Route path="/transaksi/absensi" element={<Layout breadcrumb={['Layanan','Absensi']}><Absensi /></Layout>} />
        <Route path="/transaksi/bpjs" element={<Layout breadcrumb={['Layanan','BPJS']}><Bpjs /></Layout>} />
        <Route path="/transaksi/lembur" element={<Layout breadcrumb={['Layanan','Lembur']}><Lembur /></Layout>} />
        <Route path="/transaksi/lembur-karyawan" element={<Layout breadcrumb={['Layanan','Lembur']}><LemburKaryawan /></Layout>} />
        <Route path="/transaksi/potongan" element={<Layout breadcrumb={['Layanan','Potongan Gaji']}><Potongan /></Layout>} />
        <Route path="/transaksi/insentive" element={<Layout breadcrumb={['Layanan','Insentive & Bonus']}><Insentive /></Layout>} />
        <Route path="/layanan/tunjangan" element={<Layout breadcrumb={['Layanan','Tunjangan Jabatan']}><Tunjangan /></Layout>} />
        <Route path="/layanan/tunjangan-karyawan" element={<Layout breadcrumb={['Layanan','Tunjangan Karyawan']}><MasterTunjanganKaryawan /></Layout>} />
        
        {/* LAPORAN */}
        <Route path="/laporan/gaji" element={<Layout breadcrumb={['Laporan','Gaji']}><ReportGaji /></Layout>} />
        <Route path="/laporan/absensi" element={<Layout breadcrumb={['Laporan','Absensi']}><ReportAbsensi /></Layout>} />
        <Route path="/laporan/lembur" element={<Layout breadcrumb={['Laporan','Lembur']}><ReportLembur /></Layout>} />
        <Route path="/laporan/potongan" element={<Layout breadcrumb={['Laporan','Potongan Gaji']}><ReportPotongan /></Layout>} />
        <Route path="/laporan/insentive" element={<Layout breadcrumb={['Laporan','Insentive & Bonus']}><ReportInsentive /></Layout>} />
        
        {/* SETTINGS */}
        <Route path="/settings/profile" element={<Layout breadcrumb={['Settings','Edit Profile']}><Profile /></Layout>} />
        <Route path="/settings/password" element={<Layout breadcrumb={['Settings','Ganti Password']}><Password /></Layout>} />
        <Route path="/settings/system" element={<Layout breadcrumb={['Settings','System']}><System /></Layout>} />
        <Route path="/settings/role" element={<Layout breadcrumb={['Settings','Role']}><Role /></Layout>} />
        <Route path="/settings/permission" element={<Layout breadcrumb={['Settings','Permission']}><Permission /></Layout>} />
        <Route path="/logout" element={<Logout />} />
        <Route path="*" element={<Error404 />} />
      </Routes>
    </Router>
  );
}

export default App;
